// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Be-z","heading":"Ce-z","items":"De-z","featureCss":"Ee-z","disabled":"Fe-z","imgCss":"Ge-z"};